
<ng-container *ngIf="isAuthenticated">
  <app-header [userDetails]="userDetails"></app-header>
  <router-outlet></router-outlet>
</ng-container>

<!-- <ng-template [ngIf]="!isAuthenticated">
  <p>Authenticating...</p>
</ng-template> -->
